import script from "./transfer-creation-resume-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer-creation-resume-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__